import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  previousInsurerAll: [],
  previousInsurer: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const previousInsurerSlice = createSlice({
  name: "previousInsurer",
  initialState,
  reducers: {
    setpreviousInsurerAll: (state, action) => {
      state.insurerDistrictAll = action.payload;
    },
    setpreviousInsurer: (state, action) => {
      state.insurerDistrict = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setpreviousInsurerAll,
  setpreviousInsurer,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = previousInsurerSlice.actions;

export default previousInsurerSlice.reducer;
